import PropTypes from 'prop-types';
import React from 'react';
import keyMirror from 'keymirror';

import Box from '../box/box.jsx';
import Modal from '../../containers/modal.jsx';

import ScanningStep from '../../containers/scanning-step.jsx';
import AutoScanningStep from '../../containers/auto-scanning-step.jsx';
import ConnectingStep from './connecting-step.jsx';
import ConnectedStep from './connected-step.jsx';
import ErrorStep from './error-step.jsx';
import UnavailableStep from './unavailable-step.jsx';
import XiaozhiCloudStep from './xiaozhi-cloud-step.jsx';

import styles from './connection-modal.css';

const PHASES = keyMirror({
    scanning: null,
    connecting: null,
    connected: null,
    error: null,
    unavailable: null
});

const ConnectionModalComponent = props => (
    <Modal
        className={styles.modalContent}
        contentLabel={props.name}
        headerClassName={styles.header}
        headerImage={props.connectionSmallIconURL}
        id="connectionModal"
        onHelp={props.onHelp}
        onRequestClose={props.onCancel}
    >
        <Box className={styles.body}>
            {props.isXiaozhiCloud ? (
                <XiaozhiCloudStep
                    connecting={props.xiaozhiConnecting}
                    error={props.xiaozhiError}
                    status={props.xiaozhiStatus}
                    onConnect={props.onXiaozhiConnect}
                    onDisconnect={props.onDisconnect}
                />
            ) : (
                <React.Fragment>
                    {props.phase === PHASES.scanning && !props.useAutoScan && <ScanningStep {...props} />}
                    {props.phase === PHASES.scanning && props.useAutoScan && <AutoScanningStep {...props} />}
                    {props.phase === PHASES.connecting && <ConnectingStep {...props} />}
                    {props.phase === PHASES.connected && <ConnectedStep {...props} />}
                    {props.phase === PHASES.error && <ErrorStep {...props} />}
                    {props.phase === PHASES.unavailable && <UnavailableStep {...props} />}
                </React.Fragment>
            )}
        </Box>
    </Modal>
);

ConnectionModalComponent.propTypes = {
    connectingMessage: PropTypes.node.isRequired,
    connectionSmallIconURL: PropTypes.string,
    connectionTipIconURL: PropTypes.string,
    isXiaozhiCloud: PropTypes.bool,
    name: PropTypes.node,
    onCancel: PropTypes.func.isRequired,
    onDisconnect: PropTypes.func,
    onHelp: PropTypes.func,
    onXiaozhiConnect: PropTypes.func,
    phase: PropTypes.oneOf(Object.keys(PHASES)).isRequired,
    title: PropTypes.string.isRequired,
    useAutoScan: PropTypes.bool.isRequired,
    xiaozhiConnecting: PropTypes.bool,
    xiaozhiError: PropTypes.string,
    xiaozhiStatus: PropTypes.shape({
        authorized: PropTypes.bool,
        cloudState: PropTypes.string,
        deviceCode: PropTypes.string,
        deviceStatus: PropTypes.string,
        isConnected: PropTypes.bool
    })
};

ConnectionModalComponent.defaultProps = {
    connectingMessage: 'Connecting',
    isXiaozhiCloud: false,
    xiaozhiConnecting: false,
    xiaozhiError: null,
    xiaozhiStatus: {}
};

export {
    ConnectionModalComponent as default,
    PHASES
};
